import React from 'react'
const TextInput = ctx => {
  return <input className={ ctx.validationErrors.filter(e => e.path.indexOf(ctx.name) !== -1).length > 0 ? 'is-danger input' : "input" }
    inputMode={ctx.numericKeypad ? "decimal" : "" }
    value={ctx.value}
    onChange={ctx.onChange}
    name={ctx.name}
    placeholder={ctx.placeholder}
    type={ctx.type || 'text'}/>
}

export default TextInput
